import type { MenuProps as AntdMenuProps } from "antd";
import { Menu as AntdMenu } from "antd";
import type { ArrayItem } from "@gs/core/typeUtils";

export type MenuProps = AntdMenuProps
export type MenuItem = ArrayItem<Required<MenuProps>["items"]>

export const Menu = AntdMenu;
